import { Icon } from '@mdi/react'
import { FormattedMessage } from 'react-intl'
import { mdiAlert } from '@mdi/js'

import theme from 'theme_'
import { commonMessages } from 'app/i18n/messages'
import { SomethingWentWrongContainer, SomethingWentWrongLabel } from './styles'

function SomethingWentWrongBlock() {
  return (
    <SomethingWentWrongContainer>
      <Icon path={mdiAlert} size={2} color={theme.colors.error} />
      <SomethingWentWrongLabel>
        <FormattedMessage {...commonMessages.commonError} />
      </SomethingWentWrongLabel>
    </SomethingWentWrongContainer>
  )
}

export default SomethingWentWrongBlock
